export var titleSizeMap = {
  xl: 'display-large',
  l: 'display-medium',
  m: 'display-small',
  s: 'headline-small',
  xs: 'display-extrasmall'
};
export var subTitleSizeMap = {
  xl: 'body-large',
  l: 'body-medium',
  m: 'body-small',
  s: 'body-small',
  xs: 'body-small'
};
export var titleTagMap = {
  xl: 'h1',
  l: 'h2',
  m: 'h3',
  s: 'h4',
  xs: 'h5'
};